import { ShieldCheck, Radio, FileArchive, UserCheck } from "lucide-react";

const features = [
  {
    icon: ShieldCheck,
    title: "Practice Profile Library",
    description:
      "Set up your profile once — contact details and primary modality (Naturopath, Chiropractor, Nutritionist, etc.). Every review is assessed in the context of your practice and modality, not a generic framework.",
  },
  {
    icon: Radio,
    title: "Review Your Content",
    description:
      "Your website, social posts, and clinic marketing are continuously checked against AHPRA, TGA, FSANZ and ACCC guidelines.",
  },
  {
    icon: FileArchive,
    title: "Audit Vault",
    description:
      "Every review decision is timestamped and stored in the Audit Vault retained for the duration of the subscription. If AHPRA comes asking, your evidence of systematic due diligence is already documented.",
  },
  {
    icon: UserCheck,
    title: "Human Escalation if required",
    description:
      "If you want a second opinion, escalate any review to a regulatory expert. You get clarity — not guesswork.",
  },
];

const PractitionerSolution = () => {
  return (
    <section className="py-16 sm:py-28 bg-secondary">
      <div className="container max-w-6xl px-5 sm:px-6 lg:px-8">
        <p className="section-label mb-4 text-left">THE COMPLIGUARD DIFFERENCE</p>
        <div className="teal-rule mb-6 sm:mb-8" />

        <h2 className="text-2xl sm:text-4xl font-bold text-foreground mb-4 text-left max-w-3xl">
          CompliGUARD is the infrastructure your workflow needs.
        </h2>

        <div className="text-text-body text-base sm:text-lg mb-10 sm:mb-16 text-left max-w-3xl leading-relaxed space-y-4">
          <ul className="space-y-3">
            <li className="flex items-start gap-3">
              <span className="text-primary mt-1 text-lg">✓</span>
              <span>Set up your practice profile once</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-primary mt-1 text-lg">✓</span>
              <span>Review any piece of marketing in seconds</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-primary mt-1 text-lg">✓</span>
              <span>Generate a compliant rewrite instantly</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-primary mt-1 text-lg">✓</span>
              <span>Store every decision in a defensible audit trail</span>
            </li>
          </ul>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6">
          {features.map((item) => (
            <div
              key={item.title}
              className="bg-card p-6 sm:p-8 rounded-sm border border-border card-accent-left-gold text-left shadow-[0_4px_16px_rgba(11,31,53,0.08)] card-hover"
            >
              <item.icon className="h-8 w-8 sm:h-9 sm:w-9 text-primary mb-4 sm:mb-5" />
              <h3 className="text-lg sm:text-xl font-bold text-foreground mb-2">
                {item.title}
              </h3>
              <p className="text-text-body text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PractitionerSolution;
